import { T_GmailStats, T_Meeting, T_MeetingStats } from "types";

const getDateWithTime = (hours: number, minutes: number) => {
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  return date;
};

export const fakeMeetings: T_Meeting[] = [
  {
    _id: "1",
    meetingId: "1",
    meetingName: "Product Launch Strategy",
    // today at 11:30 AM
    startAt: getDateWithTime(9, 30),
    endAt: getDateWithTime(10, 30),
    location: "Zoom",
    attendees: [
      {
        user_full_name: "Alice Johnson",
        user_email: "alice.johnson@example.com",
        position: "Product Manager",
        location: "San Francisco, CA",
        career_summary:
          "Experienced product manager with a focus on tech products, leading successful launches.",
        linkedin_profile: "https://linkedin.com/in/alicejohnson",
        profile_pic_url: "https://xsgames.co/randomusers/avatar.php?g=female",
        fun_fact: "Loves rock climbing.",
        confident: true,
        company_info: {
          name: "Tech Innovators Inc.",
          domain: "Technology",
          //   company_linkedin: 'https://linkedin.com/company/techinnovators',
          founded_year: "2010",
          annual_revenue: "50M USD",
          total_funding: "200M USD",
          location: "San Francisco, CA",
          industries: "Software, Technology",
          description: "Innovative tech solutions provider.",
          product_services: "Software Development, AI Solutions",
          employees: "500",
          website: "https://techinnovators.com",
        },
        education_summary: "MBA from Stanford University",
        icebreakers: [
          "What's your favorite product launch you've been part of?",
          "What excites you most about this upcoming launch?",
          "What challenges do you anticipate in this launch?",
        ],
      },
      {
        user_full_name: "Bob Smith",
        user_email: "bob.smith@example.com",
        position: "Marketing Director",
        location: "New York, NY",
        career_summary:
          "Marketing expert with a proven track record of successful campaigns.",
        linkedin_profile: "https://linkedin.com/in/bsmith",
        profile_pic_url: "https://xsgames.co/randomusers/avatar.php?g=male",
        fun_fact: "Plays the guitar in a band.",
        confident: true,
        company_info: {
          name: "Marketing Wizards Co.",
          domain: "Marketing",
          //   company_linkedin: 'https://linkedin.com/company/marketingwizards',
          founded_year: "2012",
          annual_revenue: "80M USD",
          total_funding: "150M USD",
          location: "New York, NY",
          industries: "Marketing, Advertising",
          description: "Leading marketing solutions provider.",
          product_services: "Digital Marketing, Content Creation",
          employees: "300",
          website: "https://marketingwizards.com",
        },
        education_summary: "BA in Marketing from NYU",
        icebreakers: ["What's the most challenging campaign you've managed?"],
        lastInteraction: {
          date: new Date("2024-08-29T15:00:00Z"),
          interactionType: "calendar",
        },
      },
    ],
    // internalAttendees: ['alice.johnson@example.com', 'bob.smith@example.com'],

    icebreakers: [
      "What excites you most about this product launch?",
      "What challenges do you anticipate in this launch?",
      "What are the key features of the new product?",
    ],
    isRecurringEvent: false,
    summary: `Meeting focused on finalizing the go-to-market strategy for the upcoming product launch.
        Key topics include target audience, marketing channels, and launch timeline.
        Attendees will discuss the product's unique value proposition and key features.
        The meeting will also cover the roles and responsibilities of the product and marketing teams in the launch process.`,
    created: new Date(),
  },
  {
    _id: "2",
    meetingId: "2",
    meetingName: "Quarterly Sales Review",
    startAt: getDateWithTime(12, 0),
    endAt: getDateWithTime(13, 0),
    location: "Google Meet",
    attendees: [
      {
        user_full_name: "Charlie Brown",
        user_email: "charlie.brown@example.com",
        position: "Sales Manager",
        location: "Chicago, IL",
        career_summary:
          "Dynamic sales manager with over 10 years of experience in B2B sales.",
        linkedin_profile: "https://linkedin.com/in/charliebrown",
        profile_pic_url: "https://xsgames.co/randomusers/avatar.php?g=male",
        fun_fact: "Enjoys cooking gourmet meals.",
        confident: true,
        company_info: {
          name: "Sales Force Ltd.",
          domain: "Sales",
          //   company_linkedin: 'https://linkedin.com/company/salesforce',
          founded_year: "2008",
          annual_revenue: "100M USD",
          total_funding: "300M USD",
          location: "Chicago, IL",
          industries: "Sales, CRM",
          description: "Leading provider of CRM solutions.",
          product_services: "CRM Software, Sales Management",
          employees: "1000",
          website: "https://salesforce.com",
        },
        education_summary: "MBA from University of Chicago",
        icebreakers: ["What's your secret to closing deals?"],
      },
      {
        user_full_name: "Dana White",
        user_email: "dana.white@example.com",
        position: "VP of Sales",
        location: "Dallas, TX",
        career_summary:
          "VP of Sales with a history of driving growth in competitive markets.",
        linkedin_profile: "https://linkedin.com/in/danawhite",
        profile_pic_url: "https://xsgames.co/randomusers/avatar.php?g=female",
        fun_fact: "Avid marathon runner.",
        confident: true,
        company_info: {
          name: "Global Ventures LLC",
          domain: "Sales",
          //   company_linkedin: 'https://linkedin.com/company/globalventures',
          founded_year: "2005",
          annual_revenue: "200M USD",
          total_funding: "500M USD",
          location: "Dallas, TX",
          industries: "Sales, Technology",
          description: "Global leader in sales technology.",
          product_services: "Sales Software, Consulting",
          employees: "2000",
          website: "https://globalventures.com",
        },
        education_summary: "BS in Business from UT Austin",
        icebreakers: ["What motivates you to lead in sales?"],
      },
    ],
    // internalAttendees: ['charlie.brown@example.com', 'dana.white@example.com'],
    icebreakers: [
      "What was the most surprising sales trend this quarter?",
      "What are the key focus areas for next quarter?",
      "What strategies have been most effective in closing deals?",
    ],
    isRecurringEvent: true,
    created: new Date(),
    summary: `Reviewing the sales performance for Q2, discussing areas of improvement and future strategies.
        Key topics include sales targets, pipeline management, and client acquisition.
        The meeting will also cover the performance of the sales team and individual sales reps.`,
  },
  {
    _id: "3",
    meetingId: "3",
    meetingName: "Tech Stack Optimization",
    startAt: getDateWithTime(14, 0),
    endAt: getDateWithTime(15, 0),
    location: "Microsoft Teams",
    attendees: [
      {
        user_full_name: "Eve Turner",
        user_email: "eve.turner@example.com",
        position: "Chief Technology Officer",
        location: "Seattle, WA",
        career_summary:
          "CTO with a focus on scalable architecture and innovative tech solutions.",
        linkedin_profile: "https://linkedin.com/in/eveturner",
        profile_pic_url: "https://xsgames.co/randomusers/avatar.php?g=female",
        fun_fact: "Passionate about open-source contributions.",
        confident: true,
        company_info: {
          name: "Tech Solutions LLC",
          domain: "Technology",
          //   company_linkedin: 'https://linkedin.com/company/techsolutions',
          founded_year: "2015",
          annual_revenue: "120M USD",
          total_funding: "400M USD",
          location: "Seattle, WA",
          industries: "Software, Technology",
          description:
            "Leader in providing scalable tech solutions for enterprises.",
          product_services: "Cloud Computing, AI Services",
          employees: "800",
          website: "https://techsolutions.com",
        },
        education_summary: "PhD in Computer Science from MIT",
        icebreakers: ["What emerging technology are you most excited about?"],
      },
      {
        user_full_name: "Frank Wilson",
        user_email: "frank.wilson@example.com",
        position: "Lead Software Engineer",
        location: "Austin, TX",
        career_summary:
          "Experienced software engineer specializing in system performance optimization.",
        linkedin_profile: "https://linkedin.com/in/frankwilson",
        profile_pic_url: "https://example.com/images/frank.jpg",
        fun_fact: "Loves building custom PCs.",
        confident: true,
        company_info: {
          name: "OptimizeTech",
          domain: "Software",
          //   company_linkedin: 'https://linkedin.com/company/optimizetech',
          founded_year: "2013",
          annual_revenue: "60M USD",
          total_funding: "200M USD",
          location: "Austin, TX",
          industries: "Software, Technology",
          description: "Specializes in software performance optimization.",
          product_services: "Performance Tools, Consulting",
          employees: "300",
          website: "https://optimizetech.com",
        },
        education_summary:
          "MS in Software Engineering from University of Texas",
        icebreakers: [
          "What's the most challenging performance issue you've solved?",
        ],
      },
    ],
    // internalAttendees: ['eve.turner@example.com', 'frank.wilson@example.com'],
    icebreakers: [
      "What's the biggest pain point in our current tech stack?",
      "What tech stack improvements are you most excited about?",
      "What are the key factors to consider when optimizing our tech stack?",
    ],
    isRecurringEvent: false,
    created: new Date(),
    summary: `Discussion on optimizing the current tech stack to enhance system performance and reduce costs.
        Key topics include evaluating current technologies, identifying bottlenecks, and exploring new solutions.`,
  },
  {
    _id: "4",
    meetingId: "4",
    meetingName: "Partnership Opportunity with XYZ Corp",
    startAt: getDateWithTime(15, 0),
    endAt: getDateWithTime(16, 0),
    location: "Zoom",
    attendees: [
      {
        user_full_name: "Grace Lee",
        user_email: "grace.lee@example.com",
        position: "Business Development Manager",
        location: "Los Angeles, CA",
        career_summary:
          "Business development expert with a focus on strategic partnerships.",
        linkedin_profile: "https://linkedin.com/in/gracelee",
        profile_pic_url: "https://xsgames.co/randomusers/avatar.php?g=female",
        fun_fact: "Enjoys surfing on weekends.",
        confident: true,
        company_info: {
          name: "Market Leaders Inc.",
          domain: "Business Development",
          //   company_linkedin: 'https://linkedin.com/company/marketleaders',
          founded_year: "2011",
          annual_revenue: "150M USD",
          total_funding: "500M USD",
          location: "Los Angeles, CA",
          industries: "Consulting, Strategy",
          description:
            "Leading consultancy in business development and strategy.",
          product_services: "Consulting, Strategic Partnerships",
          employees: "600",
          website: "https://marketleaders.com",
        },
        education_summary: "MBA from UCLA",
        icebreakers: ["What's the most impactful partnership you've formed?"],
      },
      {
        user_full_name: "Henry Adams",
        user_email: "henry.adams@example.com",
        position: "Strategic Partnerships Director",
        location: "Boston, MA",
        career_summary:
          "Director of Strategic Partnerships with a track record of successful collaborations.",
        linkedin_profile: "https://linkedin.com/in/henryadams",
        profile_pic_url: "https://xsgames.co/randomusers/avatar.php?g=male",
        fun_fact: "Speaks four languages fluently.",
        confident: false,
        company_info: {
          name: "Global Connect Ltd.",
          domain: "Partnerships",
          //   company_linkedin: 'https://linkedin.com/company/globalconnect',
          founded_year: "2007",
          annual_revenue: "250M USD",
          total_funding: "700M USD",
          location: "Boston, MA",
          industries: "Technology, Business",
          description:
            "Facilitating strategic partnerships for global enterprises.",
          product_services: "Partnerships, Consulting",
          employees: "1000",
          website: "https://globalconnect.com",
        },
        education_summary:
          "BA in International Business from Harvard University",
        icebreakers: [
          "What do you think makes a partnership truly successful?",
          "What excites you most about this potential partnership?",
          "What are the key factors you consider when evaluating a partnership opportunity?",
        ],
      },
    ],
    // internalAttendees: ['grace.lee@example.com', 'henry.adams@example.com'],
    icebreakers: [
      "What excites you most about this potential partnership?",
      "What are the key factors you consider when evaluating a partnership opportunity?",
      "What do you think makes a partnership truly successful?",
    ],
    isRecurringEvent: false,
    created: new Date(),
    summary: `Exploring a potential partnership with XYZ Corp to expand market reach and leverage their technology.
        Key topics include the scope of the partnership, mutual benefits, and collaboration opportunities.`,
  },
  {
    _id: "5",
    meetingId: "5",
    meetingName: "Customer Feedback Analysis",
    startAt: getDateWithTime(16, 0),
    endAt: getDateWithTime(17, 0),
    location: "Google Meet",
    attendees: [
      {
        user_full_name: "Isabella Martinez",
        user_email: "isabella.martinez@example.com",
        position: "Customer Success Manager",
        location: "Miami, FL",
        career_summary:
          "Customer success expert focused on improving client retention and satisfaction.",
        linkedin_profile: "https://linkedin.com/in/isabellamartinez",
        profile_pic_url: "https://xsgames.co/randomusers/avatar.php?g=female",
        fun_fact: "Loves salsa dancing.",
        confident: true,
        lastInteraction: {
          date: new Date("2024-09-18T14:00:00Z"),
          interactionType: "calendar",
        },
        company_info: {
          name: "CustomerFirst Corp.",
          domain: "Customer Service",
          //   company_linkedin: 'https://linkedin.com/company/customerfirst',
          founded_year: "2014",
          annual_revenue: "90M USD",
          total_funding: "250M USD",
          location: "Miami, FL",
          industries: "Customer Service, Technology",
          description:
            "Specializes in providing top-notch customer support solutions.",
          product_services: "Customer Support, CRM",
          employees: "600",
          website: "https://customerfirst.com",
        },
        education_summary:
          "BA in Business Administration from University of Miami",
        icebreakers: [
          "What's the most rewarding part of working in customer success?",
        ],
      },
      {
        user_full_name: "James Lee",
        user_email: "james.lee@example.com",
        position: "UX Designer",
        location: "San Diego, CA",
        career_summary:
          "UX designer with a passion for creating intuitive and engaging user experiences.",
        linkedin_profile: "https://linkedin.com/in/jameslee",
        profile_pic_url: "https://xsgames.co/randomusers/avatar.php?g=male",
        fun_fact: "Enjoys surfing in his free time.",
        confident: true,
        company_info: {
          name: "DesignCraft Studios",
          domain: "Design",
          //   company_linkedin: 'https://linkedin.com/company/designcraft',
          founded_year: "2016",
          annual_revenue: "70M USD",
          total_funding: "180M USD",
          location: "San Diego, CA",
          industries: "Design, Technology",
          description:
            "A leading design studio known for its user-centered approach.",
          product_services: "UX/UI Design, Web Development",
          employees: "400",
          website: "https://designcraft.com",
        },
        education_summary:
          "BS in Graphic Design from California State University",
        icebreakers: ["What’s your favorite design project you’ve worked on?"],
      },
    ],
    // internalAttendees: [
    //   'isabella.martinez@example.com',
    //   'james.lee@example.com',
    // ],
    icebreakers: [
      "What recent feedback surprised you the most?",
      "What are the key insights from the latest customer feedback?",
      "How do you approach analyzing customer feedback?",
    ],
    isRecurringEvent: false,
    created: new Date(),
    summary: `Analyzing recent customer feedback and planning enhancements to improve user experience.
        Key topics include feedback trends, user pain points, and feature requests.
        The meeting will also cover strategies for implementing feedback-driven improvements.`,
  },
  {
    _id: "6",
    meetingId: "6",
    meetingName: "Budget Planning for FY25",
    startAt: getDateWithTime(17, 0),
    endAt: getDateWithTime(18, 0),
    location: "Zoom",
    attendees: [
      {
        user_full_name: "Olivia Rodriguez",
        user_email: "olivia.rodriguez@example.com",
        position: "Chief Financial Officer",
        location: "Houston, TX",
        career_summary:
          "CFO with over 15 years of experience in financial planning and analysis.",
        linkedin_profile: "https://linkedin.com/in/oliviarodriguez",
        profile_pic_url: "https://xsgames.co/randomusers/avatar.php?g=female",
        fun_fact: "Has a black belt in Taekwondo.",
        confident: true,
        company_info: {
          name: "FinTech Solutions",
          domain: "Finance",
          //   company_linkedin: 'https://linkedin.com/company/fintechsolutions',
          founded_year: "2009",
          annual_revenue: "300M USD",
          total_funding: "800M USD",
          location: "Houston, TX",
          industries: "Finance, Technology",
          description:
            "Innovative fintech company providing financial solutions to enterprises.",
          product_services: "Financial Software, Consulting",
          employees: "1500",
          website: "https://fintechsolutions.com",
        },
        education_summary: "MBA from Rice University",
        icebreakers: ["What inspired you to pursue a career in finance?"],
      },
    ],
    // internalAttendees: [
    //   'olivia.rodriguez@example.com',
    //   'william.carter@example.com',
    // ],
    icebreakers: [
      "What key areas do you think we should invest in for FY25?",
      "What factors do you consider when planning the budget?",
      "What challenges do you anticipate in the budget planning process?",
    ],
    isRecurringEvent: true,
    created: new Date(),
    summary: `Initial budget planning meeting for the fiscal year 2025, focusing on key investment areas.
        Key topics include revenue projections, cost optimization, and resource allocation.
        The meeting will also cover financial goals, budget constraints, and strategic planning.`,
  },
];
const fakeMeetingStats: T_MeetingStats = {
  inPersonMeetings: "1",
  onlineMeetings: "3",
  totalMeetings: "4",
  timeInMeetings: "4h 30m",
  totalEmails: 100,
  archivedEmail: 75,
  mostArchivedLabel: "Sales",
};

// const fakeGmailStats: T_GmailStats = {
//   totalEmails: 100,
//   archivedEmail: 75,
//   mostArchivedLabel: 'Sales',

// };

export const fakeMeetingPrepData: (
  | T_Meeting
  | T_MeetingStats
  | T_GmailStats
)[] = [
  fakeMeetingStats,
  // {
  //   ...fakeMeetingStats,
  //   // podcast:
  //   //   'https://storage.googleapis.com/multiplayer-images-public/podcast-for-raymond-red',
  // },
  ...fakeMeetings,
];
